/**
 * Copiado al portapapeles.
 *
 * Reemplaza al patrón viejo de document.execCommand que quedó en
 * WebsiteConfiguration, que además depende de un input visible en el DOM.
 */

/**
 * Copia un texto al portapapeles.
 *
 * El parámetro `container` no es cosmético: el Dialog de Material-UI v4 monta
 * un TrapFocus que le devuelve el foco a su propio subárbol, así que el
 * textarea del fallback tiene que vivir dentro del diálogo. Si se cuelga de
 * document.body el select() se pierde y el execCommand copia vacío.
 *
 * @param {string} text
 * @param {?HTMLElement} container nodo donde montar el textarea del fallback
 * @returns {Promise<boolean>} false si ninguna de las dos vías funcionó
 */
export async function copyToClipboard(text, container) {
  if (!text) return false;

  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      //writeText rechaza si el documento no tiene foco: seguimos con el fallback
    }
  }

  const host = container || document.body;
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  textarea.style.opacity = '0';
  host.appendChild(textarea);

  try {
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    return document.execCommand('copy');
  } catch (e) {
    return false;
  } finally {
    host.removeChild(textarea);
  }
}

export default { copyToClipboard };
